// Stable, opt-in overrides from travel.config.text_tokens. Content is plain
// text rendered by React; this is not a DOM-wide search/replace engine.
import {isTravelHomeSectionMenuOnly} from './travelHomepage';
const own = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);
const record = value => value && typeof value === 'object' && !Array.isArray(value);

export function getTravelToken(travel, key) {
    const tokens = travel?.text_tokens;
    return record(tokens) && own(tokens, key) ? tokens[key] : undefined;
}

export function isTravelTokenHidden(travel, key) {
    return getTravelToken(travel, key)?.hidden === true;
}

export function getTravelText(travel, key, fallback, lang, variables = {}) {
    const token = getTravelToken(travel, key);
    const locale = typeof lang === 'string' ? lang : lang?.value;
    const localized = record(token) && own(token, locale) ? token[locale]?.text : undefined;
    const base = typeof token === 'string' ? token : token?.text;
    const text = [localized, base].find(value => typeof value === 'string' && value.trim());
    if (!text) return fallback;
    return text.replace(/\{([a-zA-Z][a-zA-Z0-9_]*)\}/g, (match, name) =>
        own(variables, name) ? String(variables[name] ?? '') : match);
}

export function isTravelHomeSectionHidden(context, key) {
    return context?.page?.type === 'HOME'
        && (isTravelTokenHidden(context.travel, key) || isTravelHomeSectionMenuOnly(context, key));
}
